/**
 * Slider snippet
 *
 * @class Snippet_DetailSlider
 * @extends Snippet
 */

Snippet_DetailSlider = (function (Snippet) {

  var Snippet_DetailSlider = function () {
    this.construct.apply(this, arguments);
  };

  $.extend(true, Snippet_DetailSlider.prototype, Snippet_Carousel.prototype, {

    // make li element
    makeElement: function (counter, divCounter, empty) {

      empty = empty || false;

      var element = '';
      element += ('<li data-liid="{0}" data-id="" data-counter="{0}" class="empty invisible">' +
        '	<div class="cover">' +
        '		<div class="image" style="background-image: url(\' '+this.collection.at(0).getDetailSliderImage()+' \')"></div>' +
        '		<div class="icon"/>' +
        '       <div class="gradient"></div>' +
        '       <div class="title"></div>' +
        '		<div class="label-wrapper">' +
        '		</div>' +
        '	</div>' +
        '</li>').format(counter);

      return element;

    },

    // update li element
    updateElement: function ($li, counter) {
      var empty = (0 <= counter && counter < this.collection.length) ? false : true,
        model = this.collection.at(counter),
        url = ((empty) ? '' : (model.getDetailSliderImage() ? model.getDetailSliderImage() : 'none'))

      if (this.loadedImages < this.assetsVisible + 2) {
        var img = new Image();
        img.onload = function () {
          ++this.loadedImages;
          if (this.loadedImages === this.assetsVisible || this.loadedImages === this.collection.length) {
            this.trigger('imagesloaded');
          }
        }.bind(this);
        img.src = url;
      }
      // add remove class
      $li.toggleClass('empty', (empty) ? true : false);
      $li.toggleClass('invisible', (empty) ? true : false);
      
      // whether lock icon should be displayed
      var isLocked = !(!empty && model.data.video_4k_url && (this.parent.lockClass || model.data.is_free));
      $li.toggleClass('lock', isLocked ? true : false);
      $li.toggleClass('play', !isLocked ? true : false);

      // ids
      $li.attr('data-id', ((empty) ? '' : model.getId()));
      $li.attr('data-counter', counter);

      // image

      var title = /*model.getTitle()*/ __('play');

      // title
      $('div.title', $li).html(title);

      return !empty;
    },

    onEnter: function (el) {
      var scope = this;
      var dataId = el.attr('data-id');
      if (dataId === 'right') {
        this.move(+1, true).then(function (isEnd) {
          // focus last focusable item
          Focus.to($('li.focusable', scope.$el).last());
        });
      } else if (dataId === 'left') {
        this.move(-1, true).then(function () {
          // focus first focusable item
          Focus.to($('li.focusable', scope.$el).first());
        }).catch(function (err) {
        });
      } else {
        var model = this.collection.at(el.attr('data-counter'));
        var isLocked = !(model.data.video_4k_url && (this.parent.lockClass || model.data.is_free));

        if (model.data && model.data.video_4k_url && !isLocked) {
          console.log(model);
            App.throbber();
            Router.go('player', model);
        }
          else {
            //Router.go('signin');
          }
      }
    },

    focusTo: function(idx) {
      if (idx < this.assetsVisible)
        Focus.to(this.$el.find('li[data-liid="'+idx+'"]'));
      else
        this.moveToRight(idx - this.assetsVisible + 1, idx);
    },

    moveToRight: function(offset, idx){
      console.log('~~~~~ current offset: '+offset);
      var scope = this;
      this.move( 1, true ).then( function() {
        if (--offset > 0) scope.moveToRight(offset, idx);
        else {
          Focus.to(scope.$el.find('li[data-liid="'+idx+'"]'));
        }
      }).catch(function(err) {
      });
    },

    onFocus: function ($el) {
      this.$lastFocused = $el;
      this.parent.$lastFocused = $el;
      this.parent.lastFocusedIndex = $el.attr('data-liid');
      return false;
    }
  });

  return Snippet_DetailSlider;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/detail_slider.js
// module id = 66
// module chunks = 0